import {useState} from "react";
import classNames from "classnames";
import {ClickAwayListener} from "@mui/material";
import {CountryOption} from "@/entities/country";
import {Picture} from "@/shared/ui/Picture";
import styles from "./CountrySelector.module.scss";

type Props = {
    anchorVertical?: 'top' | 'center' | 'bottom';
    anchorHorizontal?: 'left' | 'center' | 'right';
    countries: CountryOption[];
};

export const CountrySelector = (
    {
        anchorVertical = "bottom",
        anchorHorizontal = "left",
        countries = [],
    }: Props
) => {
    const [countryOpen, setCountryOpen] = useState(false);

    const currentCountry = countries[0];

    const contentClasses = classNames(
        styles.content,
        styles[`${anchorVertical}Vertical`],
        styles[`${anchorHorizontal}Horizontal`],
        {
            [styles.opened]: countryOpen
        },
    );


    const closeDropdown = () => {
        setCountryOpen(false);
    };

    const toggleDropdown = () => {
        setCountryOpen(!countryOpen);
    };

    return (
        <ClickAwayListener onClickAway={closeDropdown}>
            <div className={styles.country}>
                <button type={`button`} className={styles.trigger} onClick={toggleDropdown}>
                    <p className={styles.currentName}>{currentCountry.value}</p>
                    <Picture
                        src={currentCountry.patch}
                        alt={currentCountry.value}
                        classes={{root: styles.currentIcon}}
                        width={14}
                        height={14}
                    />
                </button>
                <div className={contentClasses}>
                    <p className={styles.contentTitle}>Выберите страну</p>
                    <div className={styles.list}>
                        {countries.map(({id, value, name, translateName, patch, link}) => {
                            if (value === 'Ru') {
                                return (
                                    <div key={id} className={classNames(styles.item, styles.active)}>
                                        <div className={styles.itemCircle}></div>
                                        <p className={styles.itemName}>{name} ({translateName})</p>
                                        <Picture
                                            src={patch}
                                            alt={value}
                                            classes={{root: styles.itemImage}}
                                            width={22}
                                            height={22}
                                        />
                                    </div>
                                );
                            } else {
                                return (
                                    <a key={id} href={link} className={styles.item}>
                                        <div className={styles.itemCircle}></div>
                                        <p className={styles.itemName}>{name} ({translateName})</p>
                                        <Picture
                                            src={patch}
                                            alt={value}
                                            classes={{root: styles.itemImage}}
                                            width={22}
                                            height={22} />
                                    </a>
                                );
                            }
                        })}
                    </div>
                </div>
            </div>
        </ClickAwayListener>
    );
}
